import {createAction, props} from '@ngrx/store';
import {InhaberDTO, ZahlungDTO} from '../../openapi/zahlung-openapi';
import {BelegDTO} from '../../openapi/beleg-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';

export class ZahlungEntitiesActions {
  static readonly prefix = '[Zahlung Entities] ';

  public static getZahlung = createAction(
    this.prefix + 'Get single zahlung.',
    props<{
      inhaberId: string;
      zahlungId: string;
    }>(),
  );

  public static getZahlungSuccess = createAction(
    this.prefix + 'Get zahlung succeeded.',
    props<{
      zahlungDto: ZahlungDTO;
    }>(),
  );

  public static readZahlungenByBelege = createAction(
    this.prefix + 'Read zahlung for every belegId.',
    props<{
      belegDtos: BelegDTO[];
    }>(),
  );

  public static readZahlungenSuccess = createAction(
    this.prefix + 'Read zahlung succeeded.',
    props<{
      zahlungDtos: ZahlungDTO[];
    }>(),
  );

  public static readZahlungenFailure = createAction(
    this.prefix + 'Read zahlung failed.',
    props<{
      error: MappedHttpErrorResponse;
    }>(),
  );

  public static deleteZahlungSuccess = createAction(
    this.prefix + 'Delete zahlung succeeded.',
    props<{
      zahlungId: string;
    }>(),
  );

  public static readTransferAllowedForInhabers = createAction(this.prefix + 'Load transfer allowed for inhaberIds.');

  public static readTransferAllowedForInhaberIdsSuccess = createAction(
    this.prefix + 'Load transfer allowed for inhaberIds succeeded.',
    props<{
      inhaberDtos: InhaberDTO[];
    }>(),
  );

  public static readTransferAllowedForInhaberIdsFailure = createAction(
    this.prefix + 'Load transfer allowed for inhaberIds failed.',
    props<{
      error: MappedHttpErrorResponse;
    }>(),
  );
}
